import { forwardRef, Ref } from 'react'
import {
  Route,
  RouteProps,
  LinkProps,
  Link,
  NavLink,
  NavLinkProps
} from 'react-router-dom'

// export const LocalizedRoute = ({
//   path,
//   children,
//   ...otherProps
// }: RouteProps) => (
//   <>
//     <Route {...otherProps} path={path} children={children} />
//     {/* <Route {...otherProps} path={path ? `/en${path}` : undefined} /> */}
//     {/* <Route {...otherProps} path={path ? `/fa${path}` : undefined} /> */}
//   </>
// )
export const LocalizedRoute = ({
  path,
  component: Component,
  ...otherProps
}: RouteProps & { component: React.ComponentType<any> }) => (
  <Route
    {...otherProps}
    path={path}
    render={(props) => <Component {...props} />}
  />
)

export const LocalizedLink = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ to, ...otherProps }: LinkProps, ref: Ref<HTMLAnchorElement>) => (
    <Link ref={ref} {...otherProps} to={`${to}`} />
  )
)

export const LocalizedNavLink = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ to, ...otherProps }: NavLinkProps, ref) => (
    <NavLink {...otherProps} to={`${to}`} />
  )
)
